var jobhajProfile = {
	bindings: {},
	/**
     * @ngInject
     */
	controller: function JobhajProfileCtrl($scope, $element, $sce, $timeout, userStore, $auth, flux, actions, DataService){

		var ctrl = this;
		var user;
		var pendingUpdate = false;
		ctrl.formData = {};
		ctrl.deleteState = 0;
		ctrl.messages = [];

		function init(){
			user = userStore.getUser();
			ctrl.formData.email = user.email;
		}

		function link(){

		}

		function onUserUpdated(data) {
			ctrl.user = userStore.getUser();
			if(!_.isEmpty(data)) {
				// console.log("JobhajProfileCtrl::onUserUpdated", data);
				
				if(pendingUpdate) {
					ctrl.addMsg({
					    content: $sce.trustAsHtml('Dine ændringer er blevet gemt 👊 💦'),
					    type: 'receive'
					});
					pendingUpdate = false;
					if(!$scope.$$phase) {
						$scope.$digest();
					}
					// ctrl.profileForm.$setPristine();
					// ctrl.profileForm.$setUntouched();
				}
			}

			
			if(!$auth.isAuthenticated()){
				window.location.href = "/";
			}
		}

		ctrl.updateUser = function updateUser(isValid) {
			// console.log('updateUser', isValid);
			// if (ctrl.validateRepeatPassword(ctrl.formData.password, ctrl.formData.password_confirmation)) {
					if (isValid) {
						// console.log("updateUser::timeout::if", isValid);
						ctrl.messages = [];
						flux.dispatch(actions.UPDATE_USER, ctrl.formData);
						pendingUpdate = true;
					}
				
			// }
		};

		ctrl.addFacebook = function addFacebook() {
			flux.dispatch('AUTHENTICATE_USER', {'type' : 'facebook'});
		};

		ctrl.deleteProfile = function deleteProfile(state) {
			// console.log(state);
			ctrl.deleteState = state;
			if(ctrl.deleteState == 2){
				flux.dispatch(actions.DELETE_USER);
			}
		};

		// ctrl.validateRepeatPassword = function validateRepeatPassword(password, repeatPassword) {
		// 	console.log('validateRepeatPassword', password);
		// 	console.log('validateRepeatPassword', repeatPassword);
		// 	if (password === repeatPassword) {
		// 		ctrl.profileForm.password_confirmation.$setValidity('repeat-password', true);
		// 		return true;
		// 	}
		// 	ctrl.profileForm.password_confirmation.$setValidity('repeat-password', false);
		// 	return false;
		// };

		ctrl.addMsg = function addMsg(message) {
		    message = {
		        content: message.content,
		        type: message.type
		    };
		    ctrl.messages.push(message);
		};

		ctrl.$onInit = init;
		ctrl.$postLink = link;

		$scope.$listenTo(userStore, ['user'], onUserUpdated);

	},
	templateUrl: './angular/components/jobhaj-profile.component.html'
};